import { render, staticRenderFns } from "./SignForm.vue?vue&type=template&id=89141442&"
import script from "./SignForm.vue?vue&type=script&lang=js&"
export * from "./SignForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports